import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {clearGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper";
import {getWmsInfo} from "@/http/services/http-services-wms";
import {loadInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {getWfsInfo, getWfsInfoByDomainID, getWfsInfoByDomainIDAndColumn} from "@/http/services/http-services-wfs";
import {loadTemporaryLayers} from "@/helpers/layer/temporary/temporary-layer-helper";
import {
    addToolsMutationSelectLayerItem,
    getToolsMutationSelectLayer, getToolsMutationSelectLayerValue
} from "@/helpers/tools/tools-mutation-select-layer-helper";
import {addFilterSelectLayerItem, getFilterSelectLayerValue} from "@/helpers/filter/filter-geometry-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {getBySelector} from "@/helpers/element-helper";
import {showNotification} from "@/helpers/notification-helper";
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";
import toastr from "toastr";
import {addPrintSelectLayerItem, getPrintSelectLayerValue} from "@/helpers/print/print-helper.js";
import {checkApplyButton} from "@/helpers/filter/filter-settings-helper.js";


window.loadAfterClickForms = []

export function callService(bookmarkPresentationID, data, type, domainID = undefined, presentationID = undefined, zoomToResult = false, coordinate = undefined, isFilterClick = false) {

    const toolsMutationSelectLayerValue = getToolsMutationSelectLayerValue()
    const toolsFilterSelectLayerValue = getFilterSelectLayerValue()
    const toolsPrintSelectLayerValue = getPrintSelectLayerValue()

    if(!toolsMutationSelectLayerValue && !toolsFilterSelectLayerValue && !toolsPrintSelectLayerValue){
        showLayerInfoButton('layer-info-info', false)
        clearGeoJsonLayers()
    }

    removeAllActiveClasses()
    getBySelector('layer-info-info-button').querySelector('.info-menu-btn').classList.add('active')

    const uiElement = 'layer-info-info-item'
    const uiElementExtra = '#divInfoMenuInfoEmpty'

    blockUi(uiElement, 0.8)
    blockUi(uiElementExtra, 0.8)

    window.lastClickedData = {
        bookmarkPresentationID: bookmarkPresentationID,
        data: data,
        type: type,
        domainID: domainID,
        presentationID: presentationID,
    }

    switch (type) {
        case 'wms':
            getWmsInfo(bookmarkPresentationID, data).then((response) => {

                return response.json()
            }).then((result) => {

                window.result = result

                result = checkResult(coordinate, result, toolsMutationSelectLayerValue, toolsFilterSelectLayerValue, toolsPrintSelectLayerValue, uiElement, uiElementExtra)

                if(!result) {
                    return
                }

                unblockUi(uiElement)
                unblockUi(uiElementExtra)
                loadInfo(result, zoomToResult, isFilterClick)
            })
            break;
        case 'wfs':
            if(domainID && presentationID) {
                getWfsInfoByDomainID(domainID, presentationID, data).then((result) => {
                    window.result = result

                    result = checkResult(coordinate, result, toolsMutationSelectLayerValue, toolsFilterSelectLayerValue, toolsPrintSelectLayerValue, uiElement, uiElementExtra)

                    console.log(result)

                    if(!result) {
                        return
                    }

                    unblockUi(uiElement)
                    unblockUi(uiElementExtra)
                    loadInfo(result, zoomToResult, isFilterClick)
                })
            } else {
                getWfsInfo(bookmarkPresentationID, data).then((result) => {
                    window.result = result

                    result = checkResult(coordinate, result, toolsMutationSelectLayerValue, toolsFilterSelectLayerValue, toolsPrintSelectLayerValue, uiElement, uiElementExtra)

                    console.log(result)

                    if(!result) {
                        return
                    }

                    if(!result || (result.features && result.features.length === 0)) {
                        showNotification('Bij deze waarde kan geen object gevonden worden', '', 'warning')
                    }

                    unblockUi(uiElement)
                    unblockUi(uiElementExtra)
                    loadInfo(result, zoomToResult, isFilterClick)
                })
            }
            break;
    }
}

export function checkResult(coordinate, result, toolsMutationSelectLayerValue, toolsFilterSelectLayerValue, toolsPrintSelectLayerValue, uiElement, uiElementExtra) {
    result = loadTemporaryLayers(coordinate, result)

    if(toolsMutationSelectLayerValue) {
        unblockUi(uiElement)
        unblockUi(uiElementExtra)
        addToolsMutationSelectLayerItem(result)
        return
    }

    if(toolsFilterSelectLayerValue) {
        unblockUi(uiElement)
        unblockUi(uiElementExtra)
        addFilterSelectLayerItem(result)
        checkApplyButton()
        return
    }

    if(toolsPrintSelectLayerValue) {
        unblockUi(uiElement)
        unblockUi(uiElementExtra)
        addPrintSelectLayerItem(result)
        return
    }

    return result
}

export function reloadServiceClick() {

    const lastClickedData = window.lastClickedData
    const lastLinkedData = window.lastLinkedData

    if(lastLinkedData) {
        window.breadCrumbs[lastLinkedData.index] = window.breadCrumbs[lastLinkedData.index].filter(breadCrumbFilter => breadCrumbFilter.Depth <= 0)
        loadLinkedData(lastLinkedData.domainID, lastLinkedData.presentationID, lastLinkedData.featureID, lastLinkedData.index)
    }else if(lastClickedData) {
        callService(lastClickedData.bookmarkPresentationID, lastClickedData.data, lastClickedData.type, lastClickedData.domainID = undefined, lastClickedData.presentationID = undefined)
    }
}

export function getWfsByColumn(domainID, presentationID, value, column) {
    getWfsInfoByDomainIDAndColumn(domainID, presentationID, value, column).then((result) => {

        if(result.features &&result.features.length === 0) {
            showNotification('Geen resultaten gevonden', '', 'warning')
            return
        }

        showLayerInfoButton('layer-info-info', false)
        clearGeoJsonLayers()
        removeAllActiveClasses()
        getBySelector('layer-info-info-button').querySelector('.info-menu-btn').classList.add('active')
        window.result = result

        loadInfo(result, true)
    })
}
